import type { ReactNode } from 'react';

type LoginGlassCardProps = {
  children: ReactNode;
  className?: string;
};

/** 로그인 카드 — 커스텀 glass */
export function LoginGlassCard({ children, className = '' }: LoginGlassCardProps) {
  return (
    <div className={`login-glass-card ${className}`.trim()}>
      <div className="login-glass-card__sheen" aria-hidden />
      <div className="login-glass-card__rim" aria-hidden />
      {children}
    </div>
  );
}
